import { getFromApi } from 'actions';
import { IAM } from 'constants';

export default resourcePath => getFromApi(`${IAM.baseUrl}${resourcePath}`);
